import $ from 'jquery';
import ScrollEffect from './lib/ScrollEffect';
import addEventListenerOnce from './lib/AddEventListnerOnce';

class Utils {
  static detectIE() {
    const ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  static isIE11() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
}

class Main {
  static init() {
    this.addIe11Class();
    this.scrollEffect();
    this.modal();
    this.scroller();
  }

  static addIe11Class() {
    if (!Utils.detectIE()) {
      return;
    }
    document.getElementsByTagName('body')[0].classList.add('ie11');
  }

  static scrollEffect() {
    const scrollEffect = new ScrollEffect();
    scrollEffect
      .addElements('.js-se')
      .init();
  }

  static modal() {
    const movie = document.querySelector('.js-movie');
    const movieIframe = movie.querySelector('iframe');
    const button = document.querySelector('.js-playMovieButton');
    const showClassName = 'show';
    const hideClassName = 'hide';
    const showModal = (e) => {
      e.stopPropagation();
      movie.classList.remove(hideClassName);
      movie.classList.add(showClassName);
      movieIframe.src = movieIframe.dataset.src;
    };
    const hideModal = (e) => {
      e.stopPropagation();
      addEventListenerOnce(movie, 'animationend', () => {
        movie.classList.remove(hideClassName);
      });
      movie.classList.remove(showClassName);
      movie.classList.add(hideClassName);
      movieIframe.src = '';
    };

    button.addEventListener('click', showModal);
    movie.addEventListener('click', hideModal);
  }

  static scroller() {
    $.extend($.easing, {
      easeOutQuart: (x, t, b, c, d) => {
        const _t = (t / d) - 1;
        return (-c * ((_t * _t * _t * _t) - 1)) + b;
      },
    })
    const $targets = $('a[href^="#"]');
    const speed = 5;
    $targets.on('click', function (e) {
      e.preventDefault();
      const $aTag = $(this);
      const hash = $aTag.attr('href');
      if (hash === '#') {
        return;
      }
      const $targetElem = $(hash);
      const currentScroll = $(window).scrollTop();
      const targetPos = $targetElem.offset().top;
      const duration = Math.max(Math.abs(currentScroll - targetPos) / speed, 1000);

      $('html, body')
        .animate({
          scrollTop: $targetElem.offset().top,
        }, duration, 'easeOutQuart').promise()
        .then(() => {
          if (/^#no-hash/.test(hash)) {
            return;
          }
          window.location.hash = hash;
        });
    });
  }
}

Main.init();
